import { render, staticRenderFns } from "./ProvidersClaims.vue?vue&type=template&id=200185ca&"
import script from "./ProvidersClaims.vue?vue&type=script&lang=js&"
export * from "./ProvidersClaims.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports